import { useDebounceFn } from '@vueuse/core'

interface Params {
  isMobile: ComputedRef<boolean>
  onCloseSidebar: () => void
}

const BLUR_DEBOUNCE_MS = 300

export function useSidebarSearch({ isMobile, onCloseSidebar }: Params) {
  const router = useRouter()

  const searchInput = ref('')
  const searchInputInFocus = ref(false)

  const handleFocus = () => {
    searchInputInFocus.value = true
  }

  const handleBlur = () => {
    searchInputInFocus.value = false
  }

  const handleBlurDebounced = useDebounceFn(handleBlur, BLUR_DEBOUNCE_MS)

  const searchHandler = (searchString: string) => {
    if (searchString === '' || searchString.length > 1) {
      handleBlur()

      router.push(searchString ? { name: '/profiles', query: { search: searchString } } : { name: '/profiles' })

      if (isMobile.value) {
        onCloseSidebar()
      }
    }
  }

  return { searchInput, searchInputInFocus, handleFocus, handleBlur, handleBlurDebounced, searchHandler }
}
